/* Gimbel Automation: Shipping Protection opt-in + checkout CTA controller.
   Loaded globally from snippets/js-variables.liquid (deferred) so it runs
   on every page, including when the cart drawer section is injected by
   the theme via fetch/innerHTML (inline <script> tags inside injected HTML
   never execute, which is why the previous in-snippet script only worked
   when the cart happened to be non-empty at page load).
   Markup and CSS live in snippets/navidium-widget.liquid. 2026-08-31.

   FIX 2026-09-02 (v3.1): the "busy" guard was set on first checkout click
   and never cleared. When the shopper reached checkout and pressed Back,
   Chrome restored the page from the back/forward cache with busy still
   true, so the capture-phase click handler preventDefault()ed the anchor
   and then silently returned: the Checkout button looked normal but did
   nothing until a hard reload. Fixed by resetting busy (and the is-busy
   class) on every pageshow, and by re-arming the button a few seconds
   after proceed() in case navigation was blocked or cancelled. */
(function () {
  'use strict';
  if (window.__gaShipV3) return;
  window.__gaShipV3 = true;
  window.navadiumStopReload = true;

  var KEY = 'ga_ship_prot';
  /* REV 2026-09-03: these are FALLBACKS only. The live copy is read from
     data-sub-on / data-sub-off on the .ga-ship row in
     snippets/navidium-widget.liquid, so wording changes are Liquid-only.
     The OFF line was rewritten from a warning ("will not be covered") to a
     neutral description of the option. */
  var SUB_ON = 'Covered against damage, loss, or theft in transit.';
  var SUB_OFF = 'Optional coverage for loss, damage, or theft in transit.';

  /* DEFAULT OFF: only an explicit '1' means on. */
  function isOn() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function setOn(v) {
    try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {}
    try { localStorage.setItem('nvd_opted_out', v ? 'false' : 'true'); } catch (e) {}
  }

  /* Navidium keeps the current cart-total tier in localStorage. We only
     read it; we never call the app's functions. */
  function protInfo() {
    var v = null, p = NaN;
    try {
      v = localStorage.getItem('nvdVariant');
      p = parseInt(localStorage.getItem('nvdProtectionPrice'), 10);
    } catch (e) {}
    return {
      variant: (v && /^\d+$/.test(String(v))) ? String(v) : null,
      cents: (p > 0) ? p : null
    };
  }

  function fmt(cents, cur) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Idempotent: every write is guarded, safe to run on every mutation. */
  function sync(root) {
    var on = isOn();
    var base = parseInt(root.getAttribute('data-base'), 10) || 0;
    var cur = root.getAttribute('data-currency') || 'USD';
    var info = protInfo();

    if (root.classList.contains('is-on') !== on) root.classList.toggle('is-on', on);

    var tog = root.querySelector('[data-ga-toggle]');
    if (tog && tog.checked !== on) tog.checked = on;

    var price = root.querySelector('[data-ga-price]');
    if (price) {
      var pt = info.cents ? '\u00b7 ' + fmt(info.cents, cur) : '';
      if (price.textContent !== pt) price.textContent = pt;
    }

    var sub = root.querySelector('[data-ga-sub]');
    if (sub) {
      var st = on
        ? (root.getAttribute('data-sub-on') || SUB_ON)
        : (root.getAttribute('data-sub-off') || SUB_OFF);
      if (sub.textContent !== st) sub.textContent = st;
    }

    var label = root.querySelector('[data-ga-label]');
    if (label && !root.querySelector('.ga-ship__checkout.is-busy')) {
      var total = base + ((on && info.cents) ? info.cents : 0);
      var lt = 'Checkout \u00b7 ' + fmt(total, cur);
      if (label.textContent !== lt) label.textContent = lt;
    }
  }

  function syncAll() {
    var els = document.querySelectorAll('[data-ga-ship]');
    for (var i = 0; i < els.length; i++) {
      try { sync(els[i]); } catch (e) {}
    }
  }

  function isProtItem(it) {
    var t = ((it.product_title || '') + ' ' + (it.title || '') + ' ' + (it.vendor || '') + ' ' + (it.handle || '')).toLowerCase();
    return t.indexOf('shipping protection') > -1 || t.indexOf('navidium') > -1;
  }

  function cartFetch(url, body) {
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts);
  }

  /* Make the cart match the switch, using Shopify's cart API directly. */
  function reconcile() {
    var on = isOn();
    var info = protInfo();
    return cartFetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart && cart.items) || [];
      var updates = {};
      var hasCorrect = false;
      items.forEach(function (it) {
        if (!isProtItem(it)) return;
        var correct = on && info.variant && String(it.variant_id) === info.variant && it.quantity === 1;
        if (correct && !hasCorrect) { hasCorrect = true; return; }
        updates[it.key] = 0;
      });
      var p = Promise.resolve();
      if (Object.keys(updates).length) {
        p = p.then(function () { return cartFetch('/cart/update.js', { updates: updates }); });
      }
      if (on && info.variant && !hasCorrect) {
        p = p.then(function () {
          return cartFetch('/cart/add.js', { items: [{ id: parseInt(info.variant, 10), quantity: 1 }] });
        }).then(function () {
          try { localStorage.setItem('cart_protection', info.variant); } catch (e) {}
        });
      } else if (!on) {
        p = p.then(function () {
          try { localStorage.removeItem('cart_protection'); } catch (e) {}
        });
      }
      return p;
    });
  }

  /* Go to checkout the way Shopify's own cart form does: POST /cart with a
     "checkout" field. Shopify responds with a redirect into the checkout.
     This is the most robust route: it carries the cart session, needs no
     user-activation timing, and is exactly what the theme's native
     checkout button does. Falls back to a plain location change. */
  function proceed() {
    try {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/cart';
      f.style.display = 'none';
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'checkout';
      i.value = 'Check out';
      f.appendChild(i);
      (document.body || document.documentElement).appendChild(f);
      f.submit();
    } catch (e) {
      window.location.href = '/checkout';
    }
  }

  var busy = false;

  /* Clear the click guard and restore every CTA to its idle state. Runs on
     pageshow (covers bfcache Back-button restores, where the JS heap comes
     back with busy === true) and as a recovery timer after proceed(). */
  function resetBusy() {
    busy = false;
    var els = document.querySelectorAll('.ga-ship__checkout.is-busy');
    for (var i = 0; i < els.length; i++) els[i].classList.remove('is-busy');
    syncAll();
  }

  function go(a) {
    if (busy) return;
    busy = true;
    a.classList.add('is-busy');
    var lbl = a.querySelector('[data-ga-label]');
    if (lbl) lbl.textContent = 'One moment\u2026';
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      proceed();
      /* If navigation did not actually happen (request blocked, shopper
         cancelled, offline error page), re-arm the button instead of
         leaving it permanently dead. If navigation succeeds, this page
         is torn down and the timer never fires. */
      setTimeout(resetBusy, 4000);
    }
    /* Never trap the shopper: navigate after 6s no matter what. */
    var guard = setTimeout(finish, 6000);
    reconcile().then(
      function () { clearTimeout(guard); finish(); },
      function () { clearTimeout(guard); finish(); }
    );
  }

  /* Delegated handlers survive drawer re-renders. Capture phase so no
     other script on the page sees the click first. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ga-toggle]')) {
      setOn(!!t.checked);
      syncAll();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var a = (e.target && e.target.closest) ? e.target.closest('[data-ga-checkout]') : null;
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    go(a);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; syncAll(); }, 50);
  }
  try {
    new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  /* Navidium writes its tier pricing to localStorage asynchronously after
     load and after cart changes; poll briefly so the price appears. */
  var n = 0;
  var iv = setInterval(function () { syncAll(); if (++n > 12) clearInterval(iv); }, 1500);
  window.addEventListener('storage', schedule);

  /* pageshow fires both on normal loads and on bfcache restores. Resetting
     here is what un-bricks the Checkout button after Back-from-checkout. */
  window.addEventListener('pageshow', function () {
    resetBusy();
    schedule();
  });
})();

/* ------------------------------------------------------------------ */
/* GA Popup Guard v1 (2026-09-02).
   Problem: the Klaviyo signup popup fires when the cart drawer opens on
   mobile and physically covers the Checkout button (verified via
   elementFromPoint hit-testing at 390px viewport).
   Fix: while the cart drawer (or the cart page checkout UI) is visibly
   on screen, hide any Klaviyo popup/flyout injected at the <body> level
   and disable its pointer events so it cannot intercept taps. The
   moment the drawer closes, everything is restored untouched, so the
   popup still does its signup job everywhere else.
   Safety: inline/embedded Klaviyo forms (e.g. the footer newsletter
   Wm7t8f) are never affected. We only hide Klaviyo nodes whose
   top-level ancestor is a direct child of <body>, and we skip any
   wrapper that contains page structure (main/header/footer) or the
   drawer itself. */
(function () {
  'use strict';
  if (window.__gaPopupGuard) return;
  window.__gaPopupGuard = true;

  function onScreen(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    if (r.bottom <= 0 || r.right <= 0) return false;
    if (r.top >= window.innerHeight || r.left >= window.innerWidth) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  /* The drawer is "open" when the ship-protection widget or the
     ga-checkout button is actually visible in the viewport. Off-canvas
     (transform) and display:none states both fail onScreen(). This also
     covers the /cart page, where suppressing the popup is desirable. */
  function drawerOpen() {
    var els = document.querySelectorAll('[data-ga-ship],[data-ga-checkout]');
    for (var i = 0; i < els.length; i++) {
      if (onScreen(els[i])) return true;
    }
    return false;
  }

  var hidden = [];
  function hidePopups() {
    var forms = document.querySelectorAll('[class*="klaviyo-form"]');
    for (var i = 0; i < forms.length; i++) {
      var top = forms[i];
      while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
      if (!top || top === document.body || top.__gaPGHidden) continue;
      /* Never touch a wrapper that contains the page itself or the drawer. */
      if (top.querySelector('main,header,footer,[data-ga-ship]')) continue;
      top.__gaPGHidden = true;
      top.__gaPGVis = top.style.visibility;
      top.__gaPGPe = top.style.pointerEvents;
      top.style.setProperty('visibility', 'hidden', 'important');
      top.style.setProperty('pointer-events', 'none', 'important');
      hidden.push(top);
    }
  }
  function restorePopups() {
    while (hidden.length) {
      var el = hidden.pop();
      el.__gaPGHidden = false;
      el.style.visibility = el.__gaPGVis || '';
      el.style.pointerEvents = el.__gaPGPe || '';
    }
  }

  var pending = null;
  function tick() {
    if (drawerOpen()) hidePopups();
    else if (hidden.length) restorePopups();
  }
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; tick(); }, 150);
  }
  try {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-hidden']
    });
  } catch (e) {}
  setInterval(tick, 500);
  document.addEventListener('click', schedule, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();
